import { createAction } from "typesafe-actions";
import {
    CountriesProps,
    WorksData,
    EducationData,
    BannerData,
    CommonImages,
    CommonPhone
} from "../../pages/types";
import {
    COMMON_IMAGES,
    COMMON_PHONES,
    COUNTRIES_UPDATE,
    EDUCATION_UPDATE,
    BANNER_UPDATE,
    USERINFO_UPDATE,
    WORKS_UPDATE,
    SHOW_ADS,
    SUBTITLES, SKILL
} from "./action-type";
import { UserStorage } from "../../units";

// 国际电话前置数字
export const countriesAction = createAction(COUNTRIES_UPDATE)<Array<CountriesProps>>();
// 工作经历
export const worksAction = createAction(WORKS_UPDATE)<Array<WorksData>>();
// 教育经历
export const educationAction = createAction(EDUCATION_UPDATE)<Array<EducationData>>();
// 个人特长
export const userSkill = createAction(SKILL)<string>();
// 用户信息
export const userInfoAction = createAction(USERINFO_UPDATE)<UserStorage | null>();

export type BannerAction = {
    active:number,
    data:Array<BannerData>
}
// 通用banner
export const bannerAction = createAction(BANNER_UPDATE,(action:BannerAction) => ({ active:action.active,data:action.data }))<BannerAction>();
// 通用Images
export const commonImagesAction = createAction(COMMON_IMAGES)<CommonImages>();
// 通用电话号码
export const commonPhones = createAction(COMMON_PHONES)<Array<CommonPhone>>();
// 广告展示
export const adsActive = createAction(SHOW_ADS)<boolean>();

type subtitle = {
    subtitleName:string,
    sortNum:number
}

export type Subtitles = Array<subtitle>
// 首页二级菜单
export const subtitlesAction = createAction(SUBTITLES)<Subtitles>()




